import React from "react";
import "./FleetTimelinePerspective.css";

export function FleetTimelinePerspective({ children, controller, fullscreen, contentStyle, zoom = 1 }) {
  return (
    <div
      ref={controller.viewportRef}
      data-fleet-perspective={controller.isInclined ? "true" : "false"}
      data-fleet-perspective-viewport="true"
      className={`fleet-perspective-viewport overflow-y-hidden ${controller.isInclined ? "fleet-perspective-active" : ""} ${zoom > 1 ? "overflow-x-auto pb-0.5" : "overflow-x-hidden pb-0.5"} ${fullscreen ? "h-full min-h-0" : ""}`}
      onDragStartCapture={controller.blockDrag}
      onDragOverCapture={controller.blockDrag}
      onDropCapture={controller.blockDrag}
    >
      <div
        className={`fleet-perspective-content relative grid min-w-full gap-1 ${fullscreen ? "h-full min-h-0 grid-rows-[auto_minmax(0,1fr)]" : ""}`}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
}
